// Limited Company Number format validation
import {extend} from "vee-validate/dist/vee-validate.full.esm";

extend('ltdCompNoValidate', {
 validate: value => (/^[A-Z][A-Z]\d\d\d\d\d\d$/.test(value) || /^\d\d\d\d\d\d\d\d$/.test(value)),
 message: '{_field_} must be either 8 digits or 2 letters followed by 6 digits'
});
// 64/8 HMRC authorisation code
extend('hmrc_648_auth_code', {
 validate: value => (/^[S][A]\d\d\d\d\d\d\d\d$/.test(value)),
 message: '{_field_} must be the letters SA followed by 8 digits'
});
// VAT number format validation
extend('VATregNoValidate', {
 validate: value => (/^\d\d\d\d\d\d\d\d\d$/.test(value)),
 message: '{_field_} must by 9 digits long'
});
// Validator for integer and decimal numbers
extend("decimal", {
 validate: (value, {decimals = '*', separator = '.'} = {}) => {
  if (value === null || value === undefined || value === '') {
   return {
    valid: false
   };
  }
  if (Number(decimals) === 0) {
   return {
    valid: /^-?\d*$/.test(value),
   };
  }
  const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
  const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

  return {
   valid: regex.test(value),
  };
 },
 message: 'The {_field_} field must contain only numeric or decimal values'
});
// Password Confirmation validation
extend('password', {
 params: ['target'],
 validate(value, {target}) {
  return value === target;
 },
 message: 'Password confirmation does not match'
});
extend('verify_password', {
 message: 'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)',
 validate: value => {
  let strongRegex = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@£$%^&*-]).{6,}$");
  return strongRegex.test(value);
 }
});
extend('payday_required', {
    message: '{_field_} must have either a worked amount or an absence reason.',
    validate: value => {
        if(value.absence_type !== null) return true;
        return value.amount >= 0;
    }
})
extend('absolute_numeric_strict', {
    message: '{_field_} X must be a valid number.',
    validate: value => {
        if(value.absence_type !== null){
            return true;
        }

        // Prevent entries like "1e5", "+4", "-3", or "3.1.4"
        const numericRegex = /^\d+(\.\d+)?$/
        return numericRegex.test(String(value.amount))
    }
})
